var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.00024L8.94 3.94024L11 3.00024L8.94 2.06024L8 0.000244141L7.06 2.06024L5 3.00024L7.06 3.94024L8 6.00024ZM12 22.0002C6.48 22.0002 2 17.5202 2 12.0002H4C4 16.4102 7.59 20.0002 12 20.0002C16.41 20.0002 20 16.4102 20 12.0002C20 7.59024 16.41 4.00024 12 4.00024V2.00024C17.52 2.00024 22 6.48024 22 12.0002C22 17.5202 17.52 22.0002 12 22.0002ZM2 9.00024L3.37 8.37024L4 7.00024L4.63 8.37024L6 9.00024L4.63 9.63024L4 11.0002L3.37 9.63024L2 9.00024ZM7 11.0002H11V7.00024H13V11.0002H17V13.0002H13V17.0002H11V13.0002H7V11.0002ZM1.37 3.37024L0 4.00024L1.37 4.63024L2 6.00024L2.63 4.63024L4 4.00024L2.63 3.37024L2 2.00024L1.37 3.37024Z",
    fill: "#A1A6B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint);
export default __webpack_public_path__ + "static/media/mint.b55c8351e8daa5ce278dd38ea07af730.svg";
export { ForwardRef as ReactComponent };